// extracted by mini-css-extract-plugin
export default {"history-card":"THnySR","title-field":"tDpWrk","title-row":"wZJqfw","title-row__title":"BmCooe","title-row__pill":"qpOywE"};